import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { suggestionContactsKeys } from './query-keys';
import { SuggestionContactAPI } from '../apis';

export type SuggestionContactType = {
  id: string;
  companyId: string;
  groupName: string;
  region: string;
  owner: string;
  createdAt: Date | string;
  createdBy: string;
  isUserSME: boolean;
  userNameToDisplay: string;
  userPrimaryCompanyId: string;
  userPrimaryCompanyName: string;
  userTitleToDisplay: string;
  userProfileImageURL: string;
};

function useSuggestionContactsQuery({
  companyId,
  shouldFetch = true,
}: {
  companyId: string;
  shouldFetch?: boolean;
}) {
  const { data: suggestionContactsData, ...rest } = useQuery<
    AxiosResponse<
      | {
          pointOfContactList: SuggestionContactType[];
        }
      | undefined
    >
  >({
    queryKey: suggestionContactsKeys.getSuggestionContacts({ companyId }),
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
    enabled: shouldFetch && !!companyId,
    queryFn: () => SuggestionContactAPI.getSuggestionContacts({ companyId }),
  });
  const suggestionContacts = useMemo(
    () =>
      suggestionContactsData?.data?.pointOfContactList &&
      Array.isArray(suggestionContactsData.data.pointOfContactList)
        ? suggestionContactsData.data.pointOfContactList || []
        : [],
    [suggestionContactsData],
  );

  return {
    suggestionContacts,
    ...rest,
  };
}

export default useSuggestionContactsQuery;
